import type { AnatomyBinding, AnatomySize } from "./componentAnatomy";
import { anatomyTextStyle } from "./componentAnatomyText";

// Mined from the three @include size(...) calls in Input.module.scss, plus
// the ghost-only .textXs 12px override.
const geometry = ({
    height,
    paddingX,
    gap,
}: {
    height: string;
    paddingX: `--${string}`;
    gap: `--${string}`;
}): readonly AnatomyBinding[] => [
    {
        partId: "background",
        property: "height",
        literal: height,
        note: "A dimension rather than a spacing step, so the sheet declares it outright.",
    },
    {
        partId: "background",
        property: "padding-inline",
        token: paddingX,
        via: "--input-padding-x",
    },
    { partId: "background", property: "gap", token: gap },
];

const sTextBindings = anatomyTextStyle({
    scale: "s",
    weight: "400",
    mixin: "text-s-14-regular",
});

const mdGeometryBindings = geometry({
    height: "28px",
    paddingX: "--space-8",
    gap: "--space-4",
});

export const inputSizes: readonly AnatomySize[] = [
    {
        id: "md",
        label: "md · 28",
        selector: ".md",
        bindings: [...mdGeometryBindings, ...sTextBindings],
    },
    {
        id: "md-xs",
        label: "md · 28 · 12px text",
        selector: ".md.textXs",
        bindings: [
            ...mdGeometryBindings,
            ...anatomyTextStyle({
                scale: "xs",
                weight: "400",
                mixin: "text-xs-12-regular",
                note: "Ghost-only 12px text (Figma 'Text size').",
            }),
        ],
    },
    {
        id: "lg",
        label: "lg · 32",
        selector: ".lg",
        bindings: [
            ...geometry({
                height: "32px",
                paddingX: "--space-12",
                gap: "--space-8",
            }),
            ...sTextBindings,
        ],
    },
    {
        id: "xl",
        label: "xl · 40",
        selector: ".xl",
        bindings: [
            ...geometry({
                height: "40px",
                paddingX: "--space-12",
                gap: "--space-8",
            }),
            ...sTextBindings,
        ],
    },
];
